import i18n from '@src/common/lib/i18n'
const DIC = {
  isIndoorList: [
    {
      label: i18n.t('cameraList.label.yes'),
      value: 1
    },
    {
      label: i18n.t('cameraList.label.no'),
      value: 0
    }
  ]
}
// 摄像机配置项type=0,摄像机，，1非摄像机
export const editDev = function (that, type = 0) {
  return {
    menuBtn: false,
    column: [
      {
        label: that.$t('cameraList.label.deviceName'),
        prop: 'deviceName',
        labelWidth: 100,
        clearable: true,
        span: 24,
        rules: [
          {
            required: true,
            message: that.$t('cameraList.placeholder.enterName'),
            trigger: 'blur'
          },
          {
            min: 1,
            max: 64,
            message: that.$t('cameraList.placeholder.lengthLess'),
            trigger: 'blur'
          }
        ]
      },
      {
        label: that.$t('cameraList.label.deviceCode'),
        prop: 'deviceNumber',
        labelWidth: 100,
        disabled: true,
        span: 24,
        placeholder: ' '
      },
      {
        label: that.$t('cameraList.label.deviceVersion'), //型号
        prop: 'deviceVersion',
        labelWidth: 100,
        disabled: true,
        placeholder: ' ',
        display: false
      },
      {
        label: that.$t('cameraList.label.statusNames'),
        prop: 'statusName',
        labelWidth: 100,
        disabled: true,
        placeholder: ' '
      },
      {
        label: that.$t('cameraList.label.deviceType'),
        prop: 'deviceTypeName',
        labelWidth: 100,
        disabled: true,
        placeholder: ' '
      },
      {
        label: that.$t('cameraList.label.wide'),
        prop: 'resolutionWide',
        labelWidth: 100,
        disabled: false,
        display: type == 1 ? false : true,
        placeholder: ' ',
        clearable: true,
        hide: false,
        rules: [
          {
            required: false,
            message: '请输入像素宽',
            trigger: 'blur'
          }
        ]
      },
      {
        label: that.$t('cameraList.label.high'),
        prop: 'resolutionHigh',
        labelWidth: 100,
        disabled: false,
        display: type == 1 ? false : true,
        placeholder: ' ',
        clearable: true,
        hide: false,
        rules: [
          {
            required: false,
            message: '请输入像素高',
            trigger: 'blur'
          }
        ]
      },
      {
        label: that.$t('cameraList.label.factory'),
        prop: 'factoryName',
        labelWidth: 100,
        disabled: true,
        placeholder: ' '
      },
      {
        label: that.$t('cameraList.label.area'),
        prop: 'areaName',
        disabled: true,
        labelWidth: 100,
        focus: () => {
          that.deviceTreeShow = true
        }
      },
      {
        label: that.$t('cameraList.label.etherIndoor'),
        prop: 'isIndoor',
        type: 'select',
        labelWidth: 100,
        formslot: true,
        editDisplay: true,
        viewDisplay: true,
        addDisplay: true,
        dicData: DIC.isIndoorList,
        mock: {
          type: 'dic'
        }
      },
      //建筑物名称：留用
      {
        label: that.$t('cameraList.label.buildName'),
        prop: 'buildName',
        disabled: true,
        display: false,
        labelWidth: 100,
        rules: [
          {
            min: 1,
            max: 60,
            message: that.$t('cameraList.message.lengthChar'),
            trigger: 'blur'
          }
        ]
      },
      //建筑物id ：留用
      {
        label: that.$t('cameraList.label.buildCode'),
        prop: 'buildingId',
        labelWidth: 100,
        disabled: true,
        display: false,
        rules: [
          {
            pattern: /^[0-9a-zA-Z]{0,30}$/,
            message: that.$t('cameraList.message.lengthCharNum'),
            trigger: 'blur'
          }
        ]
      },
      // 12
      {
        label: that.$t('cameraList.label.lng'),
        prop: 'longitude',
        labelWidth: 100,
        formslot: true,
        clearable: true,
        rules: [
          {
            required: true,
            message: that.$t('cameraList.placeholder.enterLng'),
            trigger: 'blur'
          },
          {
            pattern:
              /^[-+]?(0?\d{1,2}|0?\d{1,2}\.\d{1,10}|1[0-7]?\d{1}|1[0-7]?\d{1}\.\d{1,10}|180|180\.0{1,10})$/,
            message: that.$t('cameraList.message.numberMorn'),
            trigger: 'blur'
          }
        ]
      },
      // 13
      {
        label: that.$t('cameraList.label.lat'),
        prop: 'latitude',
        labelWidth: 100,
        formslot: true,
        clearable: true,
        rules: [
          {
            required: true,
            message: that.$t('cameraList.placeholder.enterLat'),
            trigger: 'blur'
          },
          {
            pattern:
              /^[-+]?([0-8]?\d{1}|[0-8]?\d{1}\.\d{1,10}|90|90\.0{1,10})$/,
            message: that.$t('cameraList.message.numberMorns'),
            trigger: 'blur'
          }
        ]
      },
      // 14
      {
        label: '所属楼栋',
        prop: 'BuildingName',
        labelWidth: 100,
        formslot: true,
        display: true
      },
      // 15
      {
        label: that.$t('cameraList.label.floorName'),
        prop: 'floorName',
        labelWidth: 100,
        disabled: true,
        rules: [
          {
            min: 1,
            max: 60,
            message: that.$t('cameraList.message.lengthChar'),
            trigger: 'blur'
          }
        ]
      },
      // 16
      {
        label: that.$t('cameraList.label.floorCode'),
        prop: 'floorId',
        labelWidth: 100,
        disabled: true,
        rules: [
          {
            pattern: /^[0-9a-zA-Z]{0,30}$/,
            message: that.$t('cameraList.message.lengthCharNum'),
            trigger: 'blur'
          }
        ]
      },
      {
        label: '高度',
        prop: 'altitude',
        labelWidth: 100,
        rules: [
          {
            // pattern: /^[0-9]{0,30}$/,
            required: false,
            message: '请输入高度数字,单位：m',
            trigger: ['change', 'blur']
          }
        ]
      },
      // 建议后期如果添加属性,在16之后添加,
      // {
      //   // 人脸闸机属性
      //   label: "通行方式",
      //   prop: "trafficType",
      //   type: "select",
      //   dicData: [
      //     {
      //       label: "出",
      //       value: "0"
      //     },
      //     {
      //       label: "进",
      //       value: "1"
      //     }
      //   ],
      //   labelWidth: 100,
      //   clearable: true,
      //   disabled: false,
      //   placeholder: " ",
      //   display: false
      // },
      // 17
      {
        label: that.$t('cameraList.label.mac'),
        prop: 'mac',
        labelWidth: 100,
        clearable: true,
        disabled: true,
        placeholder: ' ',
        display: false
      },

      // 18
      {
        label: that.$t('cameraList.label.attribute'),
        prop: 'cameraFeatureName',
        labelWidth: 100,
        disabled: true,
        placeholder: ' ',
        display: type == 1 ? false : true
      },
      // 19
      {
        label: 'IP',
        prop: 'ip',
        labelWidth: 100,
        clearable: true,
        disabled: false,
        placeholder: '请输入设备IP',
        display: type == 1 ? false : true
      },
      // 20
      {
        label: '端口',
        prop: 'port',
        labelWidth: 100,
        clearable: true,
        disabled: false,
        placeholder: '请输入设备端口',
        display: false
      },
      // 21
      {
        label: '实况流地址',
        prop: 'userName',
        labelWidth: 100,
        clearable: true,
        disabled: false,
        span: 24,
        placeholder: '请输入实况流地址',
        display: type == 1 ? false : true
      },
      // 22
      {
        label: '密码',
        prop: 'password',
        labelWidth: 100,
        clearable: true,
        disabled: false,
        formslot: true,
        placeholder: '请输入设备密码',
        display: false
      },
      {
        label: that.$t('cameraList.label.deviceDec'),
        type: 'textarea',
        prop: 'deviceDescription',
        labelWidth: 100,
        minRows: 5,
        maxlength: 120,
        span: 24,
        clearable: true,
        placeholder: that.$t('cameraList.message.deviceLength')
      }
    ]
  }
}
